// extracted by mini-css-extract-plugin
export default {"item":"ModelChart_item__U6BuP"};